import { useState } from 'react';

const useCustomModal = () => {
    const [modalState, setModalState] = useState({
        show: false,
        title: '',
        message: '',
        type: 'info',
        onConfirm: null,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        showCancel: true,
        confirmVariant: 'primary'
    });

    const showModal = (config) => {
        setModalState({
            ...modalState,
            show: true,
            ...config
        });
    };

    const hideModal = () => {
        setModalState({
            isVisible: false,
            message: '',
            type: 'info',
            onConfirm: null, // ← Esto es crucial
            confirmText: 'Aceptar',
            cancelText: 'Cancelar',
            showCancel: false,
            confirmVariant: 'primary'
        });
    };


    // Métodos de conveniencia para diferentes tipos de modales
    const showAlert = (message, title = 'Información') => {
        showModal({
            title,
            message,
            type: 'info',
            showCancel: false,
            confirmText: 'Aceptar'
        });
    };

    const showSuccess = (message, title = 'Éxito') => {
        showModal({
            title,
            message,
            type: 'success',
            showCancel: false,
            confirmText: 'Aceptar'
        });
    };

    const showError = (message, title = 'Error') => {
        showModal({
            title,
            message,
            type: 'error',
            showCancel: false,
            confirmText: 'Aceptar'
        });
    };

    const showWarning = (message, title = 'Advertencia') => {
        showModal({
            title,
            message,
            type: 'warning',
            showCancel: false,
            confirmText: 'Aceptar'
        });
    };

    const showConfirm = (message, onConfirm, title = 'Confirmar', confirmVariant = 'danger') => {
        showModal({
            title,
            message,
            type: 'confirm',
            onConfirm,
            confirmVariant,
            showCancel: true
        });
    };

    return {
        modalState,
        showModal,
        hideModal,
        showAlert,
        showSuccess,
        showError,
        showWarning,
        showConfirm
    };
};

export default useCustomModal;
